import React, { useEffect, useState } from 'react';
import { Flame } from 'lucide-react';
import api from '@/api';
import PillHero from './PillHero';

const fmtUsd = (n, decimals = 2) =>
  n == null ? '—' : '$' + Number(n).toLocaleString('en-US', {
    minimumFractionDigits: decimals, maximumFractionDigits: decimals,
  });

export default function CommoditiesHero() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancel = false;
    (async () => {
      try {
        const res = await api.getCommoditiesToday();
        if (!cancel) setData(res);
      } catch (_e) {
        if (!cancel) setData({ available: false });
      } finally {
        if (!cancel) setLoading(false);
      }
    })();
    return () => { cancel = true; };
  }, []);

  if (loading || !data?.available) return null;

  const asOf = data.as_of
    ? new Date(data.as_of).toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' })
    : '';

  return (
    <PillHero
      testId="commodities-hero"
      Icon={Flame}
      accent="#F97316"
      title="Today's Energy & Metals"
      subtitle={`As of ${asOf}`}
      tiles={(data.tiles || []).map((t) => ({
        label: t.label,
        primary: fmtUsd(t.value_usd, t.label.includes('COPPER') ? 3 : 2),
        badgeDirection: t.direction,
        badgeLabel: `${t.change_24h_pct >= 0 ? '+' : ''}${t.change_24h_pct.toFixed(2)}% 24h`,
      }))}
      sourceNote={data.source_note}
    />
  );
}
